import Icon from './Icon';

const Download = (props) => (
  <Icon
    {...props}
    path="M40 7.5c-17.949 0-32.5 14.551-32.5 32.5s14.551 32.5 32.5 32.5c17.949 0 32.5-14.551 32.5-32.5v0c-0.019-17.942-14.558-32.481-32.498-32.5h-0.002zM40 67.5c-15.188 0-27.5-12.312-27.5-27.5s12.312-27.5 27.5-27.5c15.188 0 27.5 12.312 27.5 27.5v0c-0.019 15.18-12.32 27.481-27.498 27.5h-0.002zM45.8 41.7l-3.333 3.333v-16.067c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0 16.033l-3.333-3.333c-0.452-0.452-1.077-0.731-1.767-0.731s-1.314 0.279-1.767 0.731v0c-0.46 0.449-0.745 1.074-0.745 1.767s0.285 1.318 0.745 1.766l0.001 0 7.567 7.567c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0l7.567-7.567c0.46-0.449 0.745-1.074 0.745-1.767s-0.285-1.318-0.745-1.766l-0.001-0c-0.447-0.422-1.051-0.682-1.716-0.682-0.682 0-1.3 0.273-1.751 0.716l0-0z"
  />
);

export default Download;
